<template>
  <div>
    <opt-event-table
        ref="table"
        :url="indexUrl"
    ></opt-event-table>
  </div>
</template>

<script>
import OptEventTable from './table';

export default {
  components: {
    OptEventTable,
  },

  props: {
    indexUrl: null,
  },
}
</script>
